import { render, staticRenderFns } from "./protectedWildPlants.vue?vue&type=template&id=52fa28f8&scoped=true&"
import script from "./protectedWildPlants.vue?vue&type=script&lang=js&"
export * from "./protectedWildPlants.vue?vue&type=script&lang=js&"
import style0 from "./protectedWildPlants.vue?vue&type=style&index=0&id=52fa28f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa28f8",
  null
  
)

export default component.exports